
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const Logout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  useEffect(() => {
    const performLogout = async () => {
      setIsLoggingOut(true);

      // Get session ID from localStorage
      const sessionId = localStorage.getItem('sessionId');

      // If we have a session ID, invalidate it on the server
      if (sessionId) {
        try {
          const response = await axios.post(`${baseUrl}/api/users/logout`, {
            sessionId
          }, {
            withCredentials: true
          });

          if (response.data.success) {
            console.log('✅ Session invalidated on server');
            // toast.success('Logged out successfully');
          } else {
            console.warn('⚠️ Logout response not successful:', response.data.message);
            toast.info('Logged out locally');
          }
        } catch (error) {
          console.error('❌ Error calling logout API:', error);
          // Don't show error toast - we still want to log out locally
          toast.info('Logged out');
        }
      }

      // Clear all authentication data from localStorage
      localStorage.removeItem('authToken');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('tenantid');
      localStorage.removeItem('ownerid');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('me');
      localStorage.removeItem('user');

      // Clear window global if it exists
      if (window.__ME__) {
        delete window.__ME__;
      }

      // Small delay to show logout message, then redirect
      setTimeout(() => {
        setIsLoggingOut(false);
        navigate('/login', { replace: true });
      }, 500);
    };

    performLogout();
  }, [navigate, baseUrl]);

  return (
    <div className="container text-center" style={{ marginTop: '50px' }}>
      <div className="card" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="card-body">
          {isLoggingOut ? (
            <>
              <h4 className="hdr hdr--primary hdr--lg">Logging out...</h4>
              <p>Please wait while we log you out.</p>
              <div className="spinner-border text-primary mt-3" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </>
          ) : (
            <>
              <h4 className="hdr hdr--primary hdr--lg">Logged Out</h4>
              <p>Redirecting to login...</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Logout;
